// Module
var code = "<div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-database-wizard-wrapper></organism-database-wizard-wrapper> ";
// Exports
module.exports = code;